import { WEBSITE_BUILDER_CURRENT_SCHEMA_VERSION } from "../websiteBuilderCurrentSchemaVersion";
import { migrateSchemaV1ToV2 } from "./versions/v1ToV2";
import { IWebsiteBuilderSchemaVersionMigrationNode } from "./helpers/migrationNode";
import { WebsiteBuilderMigrationError } from "./helpers/migrationError";
import { migrateSchemaV2ToV3 } from "./versions/v2ToV3";
import { migrateSchemaV3ToV4 } from "./versions/v3ToV4";
import { migrateSchemaV4ToV5 } from "./versions/v4ToV5";
import { migrateSchemaV5ToV6 } from "./versions/v5ToV6";
import { migrateSchemaV6ToV7 } from "./versions/v6ToV7";
import { migrateSchemaV7ToV8 } from "./versions/v7ToV8";

function migrateToNextSchemaVersion(node: IWebsiteBuilderSchemaVersionMigrationNode): IWebsiteBuilderSchemaVersionMigrationNode {
  switch (node.schemaVersion) {
    case 1:
      return migrateSchemaV1ToV2(node);
    case 2:
      return migrateSchemaV2ToV3(node);
    case 3:
      return migrateSchemaV3ToV4(node);
    case 4:
      return migrateSchemaV4ToV5(node);
    case 5:
      return migrateSchemaV5ToV6(node);
    case 6:
      return migrateSchemaV6ToV7(node);
    case 7:
      return migrateSchemaV7ToV8(node);
    default:
      throw new WebsiteBuilderMigrationError({ type: "no-migration-exists", schemaVersion: node.schemaVersion });
  }
}

export function websiteBuilderMigrateToCurrentSchemaVersion(node: IWebsiteBuilderSchemaVersionMigrationNode): IWebsiteBuilderSchemaVersionMigrationNode {  
  if (node.schemaVersion > WEBSITE_BUILDER_CURRENT_SCHEMA_VERSION) {
    throw new WebsiteBuilderMigrationError({
      type: "unsupported-future-schema-version",
      schemaVersion: node.schemaVersion,
      currentSchemaVersion: WEBSITE_BUILDER_CURRENT_SCHEMA_VERSION,
    });
  }

  if (node.schemaVersion === WEBSITE_BUILDER_CURRENT_SCHEMA_VERSION) {
    return node;
  }

  let next = node;

  while (next.schemaVersion < WEBSITE_BUILDER_CURRENT_SCHEMA_VERSION) {
    next = migrateToNextSchemaVersion(next);
  }

  return next;
}
